"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const esLocaleData = require("i18next-icu/locale-data/es");
exports.default = esLocaleData;
//# sourceMappingURL=es.js.map